module.exports = __webpack_public_path__ + "img/list_img1.8fbebd39.png";